<template>
  <tr>
    <td>
      <span class="text-sm">{{ row.article_number }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.description }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.delivered_quantity }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.unit }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.price }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.discount }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.total }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.cost_center }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.project }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.vat }}</span>
    </td>
    <td>
      <span class="text-sm">{{ row.account_number }}</span>
    </td>
    <td>
      <span class="cursor-pointer" @click="removeRow(data)">
        <feather-icon icon="Trash2Icon" />
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: "InvoiceTableRow",
  props: {
    data: {
      type: Object,
    },
    index: {
      type: Number,
    },
    booked: {
      type: Boolean,
      default: false,
      required: false,
    },
    cancelled: {
      type: Boolean,
      default: false,
      required: false,
    },
    vat_included: {
      type: Boolean,
      default: false,
      required: false,
    },
    fully_paid: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      row: {},
    };
  },
  mounted() {
    this.row = this.data;
  },
  methods: {
    removeRow(index) {
      this.$emit("removeRow", this.index);
    },
  },
};
</script>

<style lang="scss" scoped></style>
